module.exports = __webpack_public_path__ + "static/media/7. Intermitente, Óleo y resina sobre papel y latón, 37 x 64 cm, 2018 copy.7f188b6e.png";